"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _router = require("@reach/router");

var _antd = require("antd");

var _immer = _interopRequireDefault(require("immer"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _CmsLayout = _interopRequireDefault(require("../components/CmsLayout"));

var _PostForm = _interopRequireDefault(require("../components/PostForm"));

var _ListItem = _interopRequireDefault(require("../components/ListItem"));

var _Tag = _interopRequireDefault(require("../components/Tag"));

var _actions = require("../actions");

var _store = require("../store");

var _utils = require("../utils");

var _theme = require("../theme");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var PostType = function PostType(props) {
  var _sites$siteID, _sites$siteID$postTyp, _sites$siteID2, _config$fields, _config$fields$postTy, _config$fields$postTy2;

  var postTypeID = props.postTypeID;

  var _ref5 = (0, _store.useStore)(),
      _ref6 = _slicedToArray(_ref5, 2),
      _ref6$ = _ref6[0],
      config = _ref6$.config,
      _ref6$$cmsState = _ref6$.cmsState,
      sites = _ref6$$cmsState.sites,
      siteID = _ref6$$cmsState.siteID,
      dispatch = _ref6[1];

  var _ref7 = (0, _react.useState)('all'),
      _ref8 = _slicedToArray(_ref7, 2),
      filter = _ref8[0],
      setFilter = _ref8[1];

  var _ref9 = (0, _react.useState)(''),
      _ref10 = _slicedToArray(_ref9, 2),
      category = _ref10[0],
      setCategory = _ref10[1];

  var _ref11 = (0, _react.useState)(''),
      _ref12 = _slicedToArray(_ref11, 2),
      search = _ref12[0],
      setSearch = _ref12[1];

  var _ref13 = (0, _react.useState)(false),
      _ref14 = _slicedToArray(_ref13, 2),
      isSyncing = _ref14[0],
      setIsSyncing = _ref14[1];

  var postType = (_sites$siteID = sites[siteID]) === null || _sites$siteID === void 0 ? void 0 : (_sites$siteID$postTyp = _sites$siteID.postTypes) === null || _sites$siteID$postTyp === void 0 ? void 0 : _sites$siteID$postTyp[postTypeID];
  var posts = postType !== null && postType !== void 0 && postType.posts ? Object.values(postType.posts) : [];
  var visiblePosts = []; // Filter by category

  visiblePosts = !!category ? posts.filter(function (o) {
    var _o$taxonomies, _o$taxonomies$categor;

    return o === null || o === void 0 ? void 0 : (_o$taxonomies = o.taxonomies) === null || _o$taxonomies === void 0 ? void 0 : (_o$taxonomies$categor = _o$taxonomies[category === null || category === void 0 ? void 0 : category.taxonomy]) === null || _o$taxonomies$categor === void 0 ? void 0 : _o$taxonomies$categor.includes(category.term);
  }) : posts; // Filter by post status

  visiblePosts = filter === 'all' ? visiblePosts.filter(function (o) {
    return o.status !== 'trash';
  }) : visiblePosts.filter(function (o) {
    return o.status === filter;
  }); // Filter by search query

  visiblePosts = search ? visiblePosts.filter(function (o) {
    return o.title.toLowerCase().includes(search);
  }) : visiblePosts; // Sort posts by menu order

  visiblePosts = visiblePosts.sort(function (a, b) {
    return a.order > b.order ? 1 : -1;
  }); // Create data tree

  visiblePosts = (0, _utils.createDataTree)(visiblePosts);
  var taxonomies = Object.values(sites === null || sites === void 0 ? void 0 : (_sites$siteID2 = sites[siteID]) === null || _sites$siteID2 === void 0 ? void 0 : _sites$siteID2.taxonomies).filter(function (o) {
    return o === null || o === void 0 ? void 0 : o.postTypes.includes(postTypeID);
  });

  var handleSync = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _sites$siteID3;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSyncing(true);
              _context.next = 3;
              return _actions.siteActions.syncFields({
                fields: config.fields,
                apiKey: (_sites$siteID3 = sites[siteID]) === null || _sites$siteID3 === void 0 ? void 0 : _sites$siteID3.apiKey
              }, dispatch, config);

            case 3:
              setIsSyncing(false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSync() {
      return _ref15.apply(this, arguments);
    };
  }();

  var handleDuplicatePost = /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
      var postID;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              postID = _ref.postID;
              _context2.next = 3;
              return _actions.postActions.duplicatePost({
                siteID: siteID,
                id: postID
              }, dispatch, config);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleDuplicatePost(_x) {
      return _ref16.apply(this, arguments);
    };
  }();

  var handleDeletePost = /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
      var postID;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              postID = _ref2.postID;
              _context3.next = 3;
              return _actions.postActions.deletePost({
                siteID: siteID,
                id: postID
              }, dispatch, config);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleDeletePost(_x2) {
      return _ref17.apply(this, arguments);
    };
  }();

  var handleAddPost = /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref3) {
      var postTypeID, title, parentID;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              postTypeID = _ref3.postTypeID, title = _ref3.title, parentID = _ref3.parentID;
              _context4.next = 3;
              return (0, _utils.addPost)({
                site: sites[siteID],
                postTypeID: postTypeID,
                title: title,
                parentID: parentID
              }, dispatch, config);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleAddPost(_x3) {
      return _ref18.apply(this, arguments);
    };
  }();

  var handleTrashPost = /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref4) {
      var postID, result;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              postID = _ref4.postID;
              _context5.next = 3;
              return _actions.postActions.updatePost({
                siteID: siteID,
                postTypeID: postTypeID,
                id: postID,
                status: 'trash'
              }, dispatch, config);

            case 3:
              result = _context5.sent;

              if (result) {
                _antd.message.info('Post has been trashed');
              }

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleTrashPost(_x4) {
      return _ref19.apply(this, arguments);
    };
  }();

  var handleEmptyTrash = /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var result;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _actions.postActions.emptyTrash({
                siteID: siteID,
                postTypeID: postTypeID
              }, dispatch, config);

            case 2:
              result = _context6.sent;

              if (result) {
                _antd.message.info({
                  content: 'Trashed emptied successfully'
                });
              }

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function handleEmptyTrash() {
      return _ref20.apply(this, arguments);
    };
  }();

  var filterItems = /*#__PURE__*/_react.default.createElement(_antd.Tabs, {
    defaultActiveKey: "all",
    onChange: function onChange(v) {
      return setFilter(v);
    }
  }, ['all', 'publish', 'draft', 'trash'].map(function (name) {
    var count = name === 'all' ? posts.filter(function (o) {
      return o.status !== 'trash';
    }).length : posts.filter(function (o) {
      return o.status === name;
    }).length;
    return /*#__PURE__*/_react.default.createElement(_antd.Tabs.TabPane, {
      key: name,
      tab: "".concat(name.toUpperCase(), " (").concat(count, ")")
    });
  }));

  var extra = [];

  if (taxonomies && taxonomies.length > 0) {
    extra.push( /*#__PURE__*/_react.default.createElement(_antd.Select, {
      key: "taxonomies",
      style: {
        width: 160
      },
      onChange: function onChange(v, o) {
        return setCategory(o !== null && o !== void 0 && o.taxonomy ? {
          taxonomy: o.taxonomy,
          term: v
        } : '');
      },
      allowClear: true,
      placeholder: "Select category"
    }, taxonomies.map(function (o) {
      return /*#__PURE__*/_react.default.createElement(_antd.Select.OptGroup, {
        key: o.id,
        label: o.title
      }, o.terms && o.terms.map(function (p) {
        return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
          key: p.id,
          value: p.id,
          taxonomy: o.id
        }, p.title);
      }));
    })));
  }

  extra.push( /*#__PURE__*/_react.default.createElement(_antd.Input.Search, {
    key: "search",
    allowClear: true,
    defaultValue: search,
    onChange: function onChange(e) {
      return setSearch(e.target.value.toLowerCase());
    }
  }));

  if (filter === 'trash') {
    extra.push( /*#__PURE__*/_react.default.createElement(_antd.Popconfirm, {
      title: "Are you sure you want to empty the trash?",
      onConfirm: handleEmptyTrash,
      okText: "Yes",
      cancelText: "No",
      placement: "bottomRight",
      disabled: visiblePosts.length === 0
    }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
      key: "empty-trash",
      children: 'Empty trash',
      disabled: visiblePosts.length === 0,
      type: "danger"
    })));
  } else {
    extra.push( /*#__PURE__*/_react.default.createElement(_antd.Button, {
      key: "add",
      children: "Add",
      disabled: !postType,
      onClick: function onClick() {
        return dispatch({
          type: 'SET_DIALOG',
          payload: {
            open: true,
            title: "Add ".concat(postType.title),
            component: /*#__PURE__*/_react.default.createElement(_PostForm.default, {
              onSubmit: handleAddPost,
              postTypeID: postTypeID
            })
          }
        });
      },
      type: "primary"
    }));
  }

  var renderPost = function renderPost(o, level) {
    var _sites$siteID4, _sites$siteID5, _o$locked;

    var slug = "/".concat((0, _utils.generateSlug)(postType, o.id, sites === null || sites === void 0 ? void 0 : (_sites$siteID4 = sites[siteID]) === null || _sites$siteID4 === void 0 ? void 0 : _sites$siteID4.frontPage));
    var actions = [];
    var isLocked = !!o.locked;

    var menu = /*#__PURE__*/_react.default.createElement(_antd.Menu, null, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
      key: "duplicate",
      onClick: function onClick() {
        return handleDuplicatePost({
          postID: o.id
        });
      }
    }, "Duplicate"), o.status === 'trash' ? /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
      key: "delete",
      danger: true,
      onClick: function onClick() {
        return handleDeletePost({
          postID: o.id
        });
      },
      disabled: isLocked
    }, "Delete") : /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
      key: "trash",
      danger: true,
      onClick: function onClick() {
        return handleTrashPost({
          postID: o.id
        });
      },
      disabled: isLocked
    }, "Trash"));

    actions.unshift( /*#__PURE__*/_react.default.createElement(_antd.Dropdown.Button, {
      overlay: menu,
      trigger: ['click']
    }, /*#__PURE__*/_react.default.createElement(_router.Link, {
      to: slug
    }, isLocked ? 'View' : 'Edit')));
    var badges = [];

    if ((sites === null || sites === void 0 ? void 0 : (_sites$siteID5 = sites[siteID]) === null || _sites$siteID5 === void 0 ? void 0 : _sites$siteID5.frontPage) === o.id) {
      badges.push( /*#__PURE__*/_react.default.createElement(_Tag.default, {
        key: "front",
        children: 'front'
      }));
    }

    if (o.status === 'draft' || o.status === 'trash') {
      badges.push( /*#__PURE__*/_react.default.createElement(_Tag.default, {
        key: "status",
        children: o.status
      }));
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: o.id
    }, /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      level: level,
      actions: actions,
      title: o.title,
      subtitle: slug,
      status: badges,
      image: o.featuredImage,
      showImage: postTypeID !== 'page',
      link: slug,
      info: isLocked && "".concat((_o$locked = o.locked) === null || _o$locked === void 0 ? void 0 : _o$locked.email, " is currently editing")
    }), o.childNodes.map(function (p) {
      return renderPost(p, level + 1);
    }));
  };

  var getListStyle = function getListStyle(isDraggingOver) {
    return {
      background: isDraggingOver ? _theme.colors.tertiary : 'transparent'
    };
  };

  var getItemStyle = function getItemStyle(isDragging, draggableStyle) {
    return _objectSpread({
      userSelect: 'none',
      marginBottom: '8px'
    }, draggableStyle);
  };

  var handleDragEnd = /*#__PURE__*/function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(result) {
      var index, newIndex, nextPosts;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (result.destination) {
                _context7.next = 2;
                break;
              }

              return _context7.abrupt("return");

            case 2:
              index = result.source.index;
              newIndex = result.destination.index;

              if (!(index === newIndex)) {
                _context7.next = 6;
                break;
              }

              return _context7.abrupt("return");

            case 6:
              nextPosts = (0, _immer.default)(visiblePosts, function (draft) {
                if (newIndex > -1 && newIndex < draft.length) {
                  var temp = draft[index];
                  draft[index] = draft[newIndex];
                  draft[newIndex] = temp;
                  draft.map(function (o, i) {
                    return draft[i] = _objectSpread(_objectSpread({}, o), {}, {
                      order: i
                    });
                  });
                }

                return draft;
              });
              _context7.next = 9;
              return _actions.postActions.reorderPosts({
                siteID: siteID,
                postType: postType,
                posts: nextPosts
              }, dispatch, config);

            case 9:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function handleDragEnd(_x5) {
      return _ref21.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_CmsLayout.default, {
    pageTitle: (config === null || config === void 0 ? void 0 : (_config$fields = config.fields) === null || _config$fields === void 0 ? void 0 : (_config$fields$postTy = _config$fields.postTypes) === null || _config$fields$postTy === void 0 ? void 0 : (_config$fields$postTy2 = _config$fields$postTy[postTypeID]) === null || _config$fields$postTy2 === void 0 ? void 0 : _config$fields$postTy2.title) || (postType === null || postType === void 0 ? void 0 : postType.title)
  }, /*#__PURE__*/_react.default.createElement(_antd.PageHeader, {
    title: filterItems,
    extra: extra
  }), !postType && /*#__PURE__*/_react.default.createElement(_antd.Alert, {
    message: "Unknown post type",
    description: "Restart the development process or sync new data now",
    type: "info",
    showIcon: true,
    action: /*#__PURE__*/_react.default.createElement(_antd.Button, {
      size: "small",
      type: "ghost",
      onClick: handleSync,
      loading: isSyncing
    }, "Sync to WordPress")
  }), visiblePosts && /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 8
  }, filter === 'all' && postTypeID !== 'page' ? /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: handleDragEnd
  }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "droppable"
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, provided.droppableProps, {
      ref: provided.innerRef,
      style: getListStyle(snapshot.isDraggingOver)
    }), visiblePosts.map(function (o, i) {
      return /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Draggable, {
        key: o.id,
        draggableId: "item-".concat(o.id),
        index: i
      }, function (provided, snapshot) {
        return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
          ref: provided.innerRef
        }, provided.draggableProps, provided.dragHandleProps, {
          style: getItemStyle(snapshot.isDragging, provided.draggableProps.style)
        }), renderPost(o, 0));
      });
    }), provided.placeholder);
  })) : visiblePosts.map(function (o) {
    return renderPost(o, 0);
  })));
};

var _default = PostType;
exports.default = _default;